import { render, staticRenderFns } from "./AbholungStartenTisch.vue?vue&type=template&id=633ebdb6"
import script from "./AbholungStartenTisch.vue?vue&type=script&lang=ts"
export * from "./AbholungStartenTisch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports